<template>
  <div class="sidepanel-deadline">
    <!-- Deadline section start-->
    <div class="text-size-14 text-weight-bold mt-2">{{ $t('options.lbDeadline') }}</div>

    <div class="row justify-content-start align-items-center mx-0 deadline">
      <div
        @click="showDeadlinePicker = true"
        class="d-flex mr-1 pointer text-size-16"
      >
        {{ curDeadline }}
      </div>
      <BtnLink
        v-if="pollDeadline"
        @click.native="removeDeadline"
        class=""
        :label="$t('headline.remove')"
      />

      <BtnLink
        v-if="showDeadlinePicker"
        @click.native="showDeadlinePicker = false"
        class=""
        :label="$t('options.deadlineSetText')"
      />

      <BtnLink
        v-if="!showDeadlinePicker"
        @click.native="showCalendar"
        class=""
        :label="btnLabelAdddeadline"
      />

      <BtnLink
        v-if="showDeadlinePicker"
        @click.native="cancelCalendar"
        class=""
        :label="$t('general.cancel')"
      />
    </div>

    <div v-if="pollDeadline" class="user-time-zone text-size-14">
      <span class="text-size-12">{{ $t('general.timeZone') }}: </span>
      {{ Intl.DateTimeFormat().resolvedOptions().timeZone }}
    </div>
    <div v-if="showDeadlinePicker" class="row justify-content-center">
      <vc-date-picker
        v-model="pollDeadline"
        :attributes="attrs"
        :columns="$screens({ default: 1, lg: 2 })"
        :theme-styles="themeStyles"
        mode="dateTime"
        :is24hr="true"
        :timezone="timezone"
        is-dark
        is-inline
        :locale="locale"
      />
    </div>
    <span v-if="0&&pollDeadline"> {{ pollDeadline.toISOString() }} - {{ Date() }} </span>
    <!-- :min-date="getTodayDate"  -->

    <!-- Deadline section end-->
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { dateMixin } from '@/components/mixins/DateMixins.js';

export default {
  name: 'EditPollDeadline',
  mixins: [dateMixin],
  data() {
    const hSpacing = '15px';    

    return {
      showDeadlinePicker: false,
      backupDeadline: null,
      pollDeadline: null,
      themeStyles: {
        wrapper: {
          background: 'linear-gradient(to bottom right, #ff5050, #ff66b3)',
          color: '#fafafa',
          border: '0',
          boxShadow:
            '0 4px 8px 0 rgba(0, 0, 0, 0.14), 0 6px 20px 0 rgba(0, 0, 0, 0.13)',
          borderRadius: '5px',
        },
        header: {
          padding: `20px ${hSpacing}`,
        },
        headerHorizontalDivider: {
          borderTop: 'solid rgba(255, 255, 255, 0.2) 1px',
          width: '80%',
        },
        weekdays: {
          color: '#6eded1', // New color
          fontWeight: '600', // And bolder font weight
          padding: `20px ${hSpacing} 5px ${hSpacing}`,
        },
        weeks: {
          padding: `0 ${hSpacing} ${hSpacing} ${hSpacing}`,
        },
        dayContent: {
          fontSize: '0.9rem',
        },
      },

    };
  },

  watch: {
    pollDeadline: {
      deep: true,
      handler: function () {
        // if (!this.pollDeadline) {
        //   // when unhide the choice deadline, please remove this one
        //   this.delayType = null;
        //   this.delayInterval = null;
        // } else if (this.pollDeadline && this.delayType == 'before_next_date') {
        //   this.delayType = null;
        // }
        // console.log('date was updated', this.pollDeadline);
        //this.showDeadlinePicker = false;
        this.$store.commit('updateDeadline', this.pollDeadline);
      },
    },

  },



  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
    //   ownerId: (state) => state.poll.poll.user.id,
    //   user: (state) => state.Login.user,
    }),

    locale() {
      return this.$store.getters.userLocale;
    },

    timezone() {
      return '';
    },


    curDeadline() {
      if (!this.pollDeadline) {
        return this.$t('options.noDeadline') + ' ';
      }

      // let deadline = this.fullWeekDay(this.pollDeadline) + ' ';
      // deadline += this.dayMonthYear(this.pollDeadline);
      const locale = this.$i18n.locale;
      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      };
      return new Date(this.poll.deadline).toLocaleString(locale, options);
    },

    btnLabelAdddeadline() {
      if (this.pollDeadline) {
        return this.$t('general.change');
      }
      return this.$t('general.add');
    },

  },

  methods: {
    removeDeadline() {
        this.pollDeadline = null;
    },
    showCalendar() {
      if (this.poll.deadline) {
        this.pollDeadline = new Date(this.poll.deadline);
      } else {
        let today = new Date();
        today.setHours(23, 59, 0, 0);
        this.pollDeadline = today;
      }

      this.showDeadlinePicker = true;
      console.log('showCalendar:', this.pollDeadline);
    },

    cancelCalendar() {
      this.poll.deadline = this.backupDeadline;
      if (!this.poll.deadline) this.pollDeadline = null;
      console.log('Cancel deadline:', this.poll.deadline);
      this.showDeadlinePicker = false;
    },
  },
  mounted() {
    this.backupDeadline = this.poll.deadline;
    if (this.poll.deadline) {
      this.pollDeadline = new Date(this.poll.deadline);
    }
  },
};
</script>

<style lang="scss" scoped>

.deadline > .btn-sm {
  padding-left: 4px;
  padding-right: 4px;
}

</style>